import FunctionHelper from "../../../../../shared/helper/FunctionHelper";
import {FormFieldSubType} from "../FormFieldSubType";
import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";

export default class FormValue implements Parameter {
	public value?: any;
	public type?: FormFieldSubType;
	public name?: string;
	public fullyQualifiedName?: string;
	public isRichtext: boolean;

	constructor(data: any) {
		let type: FormFieldSubType = FunctionHelper.exists(data?.type) ? data.type : FormValue.getTypeDefault();
		this.type = type;
		this.value = FunctionHelper.exists(data?.value) ? data.value : FormValue.getValueDefault(type);
		this.name = FunctionHelper.exists(data?.name) ? data.name : FormValue.getNameDefault();
		this.fullyQualifiedName = FunctionHelper.exists(data?.fullyQualifiedName) ?
			data.fullyQualifiedName : FormValue.getFullyQualifiedNameDefault();
		this.isRichtext = FunctionHelper.exists(data?.isRichtext) ? data.isRichtext : false;
	}

	public static getValueDefault(type: FormFieldSubType, value?: string): any {
		switch (type) {
			case FormFieldSubType.TEXT:
			case FormFieldSubType.COMBOBOX:
			case FormFieldSubType.RADIOBUTTON:
			case FormFieldSubType.CHECKBOX:
				if (FunctionHelper.exists(value)) {
					return value;
				}

				return "";
			case FormFieldSubType.LISTBOX:
				if (FunctionHelper.exists(value)) {
					return value!.split(",");
				}

				return [];
			default:
				return undefined;
		}
	}

	public static getTypeDefault(): FormFieldSubType {
		return FormFieldSubType.TEXT;
	}

	public static getNameDefault(): string {
		return "";
	}

	public static getFullyQualifiedNameDefault(): string {
		return "";
	}

	public static fromJson(data: any): FormValue {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new FormValue(data);
	}

	public toJson(): any {
		return {
			'type': this.type,
			'value': this.value,
			'name': this.name,
			'fullyQualifiedName': this.fullyQualifiedName,
			'isRichtext': this.isRichtext
		};
	}

	public clone(): FormValue {
		return FormValue.fromJson(this.toJson());
	}
}